
import { LoanTransactionWithDetails } from '@/loan/types/loan-transaction-with-details';
import moment from 'moment';
import {
	Component, Vue, Prop,
} from 'vue-property-decorator';
import { LOAN_TRANSACTION_HEADERS } from '@/loan/constants/loan-transaction-headers';
import { LoanHelper } from '@/loan/helper';
import { UtilHelper } from '@/util/helper';

@Component
export default class LoanSummaryRecentTransactions extends Vue {
	public formatAmount = LoanHelper.getTransactionAmountText;

	public formatDate = (date: string) => moment(date).format('MM/DD/YYYY');

	public formatDollar = UtilHelper.formatDollar;

	public formatStatus = LoanHelper.resolveTransactionStatusId;

	public formatType = LoanHelper.resolveTransactionTypeId;

	public headers = LOAN_TRANSACTION_HEADERS;

	@Prop({ required: true })
	public loanId!: string;

	@Prop({ required: true })
	public transactions!: LoanTransactionWithDetails[];
}
